import { render, staticRenderFns } from "./CustomerTemplateConfiguration.vue?vue&type=template&id=83722b5c&"
import script from "./CustomerTemplateConfiguration.vue?vue&type=script&lang=js&"
export * from "./CustomerTemplateConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTemplateConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports